/*----------------------------------------------------------------------------*\
  #TOGGLE PASSWORD
\*----------------------------------------------------------------------------*/

// Default module export
export default function(options) {
  // Private: Default settings object
  const _defaults = {
    selector: '[data-toggle-password]',
    $selectors() {
      return document.querySelectorAll(this.selector);
    },
    exists() {
      return this.$selectors().length > 0;
    },
    showText: 'Show',
    hideText: 'Hide',
  };

  // Private: Merge passed in object with defaults
  const _settings = {
    ..._defaults,
    ...options,
  };

  // Private: Toggle password visibility
  const _toggleVisibility = event => {
    const button = event.currentTarget;
    const inputId = button.getAttribute('data-toggle-password');
    const input = document.getElementById(inputId);

    if (!input) return;

    if (input.type === 'password') {
      input.type = 'text';
      button.textContent = _settings.hideText;
    } else {
      input.type = 'password';
      button.textContent = _settings.showText;
    }
  };

  // Private: Update button disabled state based on input value
  const _updateButtonState = event => {
    const input = event.currentTarget;
    const button = document.querySelector(`[data-toggle-password="${input.id}"]`);

    if (!button) return;

    button.disabled = input.value.length === 0;
  };

  // Private: Get input for button
  const _getInputForButton = button => {
    const inputId = button.getAttribute('data-toggle-password');
    return document.getElementById(inputId);
  };

  // Public: Destroy module instance
  const destroy = () => {
    if (!_settings.exists()) return;

    _settings.$selectors().forEach($button => {
      $button.removeEventListener('click', _toggleVisibility);

      const input = _getInputForButton($button);
      if (input) {
        input.removeEventListener('input', _updateButtonState);
      }
    });
  };

  // Public: Destroy module instance and run initialise again
  const reinit = () => {
    destroy();
    init();
  };

  // Public: Initialise module
  const init = () => {
    if (!_settings.exists()) return;

    _settings.$selectors().forEach($button => {
      $button.addEventListener('click', _toggleVisibility);

      const input = _getInputForButton($button);
      if (input) {
        // Set initial disabled state
        $button.disabled = input.value.length === 0;

        // Listen for input changes
        input.addEventListener('input', _updateButtonState);
      }
    });
  };

  // Return public methods
  return {
    destroy,
    reinit,
    init,
  };
}
